import { c as _c } from "react/compiler-runtime";
import { getSchemeSafeUrl } from '@onefootprint/core';
import type { FootprintVariant } from '@onefootprint/footprint-js-legacy';
import Idv, { AppErrorBoundary, Logger, trackAction } from '@onefootprint/idv';
import type { GetServerSideProps } from 'next';
import useHostedMachine from 'src/hooks/use-hosted-machine';
import Layout from '../components/layout';
import Complete from './complete';
import ErrorPage from './error-page';
import Init from './init';
import Intro from './intro';
type RootProps = {
  variant?: FootprintVariant;
};
const Root = t0 => {
  const $ = _c(30);
  const {
    variant
  } = t0;
  const [state, send] = useHostedMachine();
  const {
    businessBoKycData,
    obConfigAuth,
    authToken
  } = state.context;
  let t1;
  if ($[0] !== businessBoKycData) {
    t1 = businessBoKycData || {};
    $[0] = businessBoKycData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    invitedData
  } = t1;
  let t2;
  if ($[2] !== send) {
    t2 = t3 => {
      const {
        validationToken,
        hasCompletionScreen
      } = t3;
      trackAction("hosted:completed");
      Logger.info("IDV flow is completed on hosted");
      if (!hasCompletionScreen) {
        send({
          type: "idvCompleted"
        });
      }
      const params = new URLSearchParams(window.location.search);
      const redirectUrl = getSchemeSafeUrl(params.get("redirect_url"));
      if (redirectUrl && validationToken) {
        const url = new URL(redirectUrl);
        url.searchParams.set("validation_token", validationToken);
        window.location.href = url.toString();
        return;
      }
      Logger.stopSessionReplay();
    };
    $[2] = send;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleComplete = t2;
  const handleAutoAdvance = _temp;
  let t3;
  if ($[4] !== send) {
    t3 = () => {
      send({
        type: "reset"
      });
    };
    $[4] = send;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== state) {
    t4 = state.matches("init") ? <Init /> : null;
    $[6] = state;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== state) {
    t5 = state.matches("intro") ? <Intro /> : null;
    $[8] = state;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== state) {
    t6 = state.matches("error") ? <ErrorPage /> : null;
    $[10] = state;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== authToken || $[13] !== handleComplete || $[14] !== invitedData || $[15] !== obConfigAuth || $[16] !== state) {
    t7 = state.matches("idv") ? <Idv bootstrapData={invitedData} authToken={authToken} obConfigAuth={obConfigAuth} onComplete={handleComplete} autoAdvance={{
      mode: "navigate",
      onDone: handleAutoAdvance
    }} showLogo={true} /> : null;
    $[12] = authToken;
    $[13] = handleComplete;
    $[14] = invitedData;
    $[15] = obConfigAuth;
    $[16] = state;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== state) {
    t8 = state.matches("complete") ? <Complete /> : null;
    $[18] = state;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t9 = <AppErrorBoundary onReset={t3}>{t4}{t5}{t6}{t7}{t8}</AppErrorBoundary>;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t9 || $[28] !== variant) {
    t10 = <Layout variant={variant}>{t9}</Layout>;
    $[27] = t9;
    $[28] = variant;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
};
export const getServerSideProps: GetServerSideProps = async ({
  query,
  res
}) => {
  res.setHeader('Cache-Control', 'public, s-maxage=30, stale-while-revalidate=3600');
  return {
    props: {
      language: query.lng ?? 'en'
    }
  };
};
export default Root;
function _temp(href) {
  Logger.info("Completion screen continued on its own");
  window.location.href = href;
}